import React, { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Modal } from "@mui/material";
import PdfFile, { generateAndSendPdf } from "./PdfFile";

const DigitalSignaturePopup = ({ open, onClose, onSave, formData , setLetterOfAuthenticationPopup}) => {
  const sigCanvas = useRef(null);
  const [signature, setSignature] = useState("");
  const [generatePdf, setGeneratePdf] = useState(false);

  const clearSignature = () => {
    sigCanvas.current.clear();
  };

  const saveSignature = async () => {
    try {
      if (!sigCanvas.current) {
        throw new Error("Signature canvas not initialized");
      }

      const signatureData = sigCanvas.current
        .getSignaturePad()
        .toDataURL("image/png");

      setSignature(signatureData);
      onSave(signatureData);
      setGeneratePdf(true);
      onClose();

      await generateAndSendPdf({ ...formData, signature: signatureData },onClose);
      
    } catch (error) {
      console.error("Signature Error:", error);
      alert("Error generating signature. Please try again.");
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div
          className="custom_modal"
          style={{ maxHeight: "90vh", paddingTop: "20px" }}
        >
          <div className="am_pm flex items-center justify-center">
            <p className="font-bold text-lg"> Sign Below </p>
          </div>
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            minWidth={2}
            maxWidth={4}
            dotSize={3}
            canvasProps={{
              width: 430,
              height: 500,
              className: "signatureCanvas",
              style: { border: "2px solid black", borderRadius: "5px" },
            }}
          />

          <div className="signature-buttons">
            <button onClick={clearSignature}>Clear</button>
            <button onClick={saveSignature}> Send PDF </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DigitalSignaturePopup;
